<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="tms">N</span>
          <input
            type="text"
            :placeholder="$t('search')"
            v-model="searchUsers"
          />
        </div>
        <span class="tms modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content">
        <div
          class="modal-content-check"
          :class="{ 'modal-content-check-disabled': u.isDisabled }"
          v-for="u in filteredUsers"
          :key="`addUsersModal-${u._id}`"
          :title="
            selectedUsersType === 'groups' ? u.users.map((x) => x.name) : ''
          "
        >
          <span
            v-if="isCommingFromCompany && u.permissions.isLeader"
            @click="setLeader(u)"
            class="tms tms-leader"
            :class="{ 'tms-leader--active': u.isObjectLeader }"
            >#</span
          >
          <Checkbox
            :value="u.isSelected"
            :label="
              selectedUsersType === 'workers-groups'
                ? `${u.worker.name} - ${u.name}`
                : u.name
            "
            @input="
              isCommingFromReport
                ? u.useIncomingWage
                  ? (u.useIncomingWage = false)
                  : null
                : null,
                setSelectedUsersOrGroups(u)
            "
            :disabled="u.isDisabled"
          />
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="(groups.length || users.length) && !filteredUsers.length"
        >
          {{ $t("no-results-for") }}
          <strong>{{ this.searchUsers }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="select-btns" v-if="allUsers">
          <button
            class="btn btn-select"
            :class="{ 'btn--selected': selectedUsersType === 'groups' }"
            @click="getUsers('groups')"
          >
            <span class="tms">W</span>
            {{ $t("users-groups") }}
          </button>
          <button
            class="btn btn-select"
            :class="{ 'btn--selected': selectedUsersType === 'reporters' }"
            @click="getUsers('reporters')"
          >
            <span class="tms">W</span>
            {{ $t("users-vas") }}
          </button>
          <!-- <button
            class="btn btn-select"
            :class="{ 'btn--selected': selectedUsersType === 'workers' }"
            @click="getUsers('workers')"
          >
            <span class="tms">W</span>
            {{ $t("Workers") }}
          </button> -->
          <button
            class="btn btn-select"
            :class="{ 'btn--selected': selectedUsersType === 'workers-groups' }"
            @click="getUsers('workers-groups')"
          >
            <span class="tms">W</span>
            {{ $t("users-workers-groups") }}
          </button>
          <!-- <button class="btn btn-select" @click="toggleUsers(true)">
            <span class="tms">W</span>
            {{ $t("all") }}
          </button>
          <button class="btn btn-select" @click="toggleUsers(false)">
            <span class="tms">X</span>
            {{ $t("none") }}
          </button> -->
        </div>
        <div v-else></div>
        <button class="btn btn-new" @click="save()">
          <span class="tms">Y</span>
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "./Checkbox.vue";
export default {
  components: {
    Checkbox,
  },
  props: [
    "usersType",
    "incomingUsers",
    "date",
    "isCommingFromReport",
    "isCommingFromGroup",
    "isCommingFromCompany",
    "allUsers",
    "groupId",
  ],
  data() {
    return {
      users: [],
      groups: [],
      // workers: [],
      workerGroups: [],
      searchUsers: "",
      selectedUsersType: "reporters",
    };
  },
  computed: {
    filteredUsers() {
      return this.filterUsers();
    },
  },
  methods: {
    async setDisabledUsers() {
      for (let u of this.users) {
        // if (this.isCommingFromReport && this.date) {
        //   // ?ignoreReports=true
        //   const url = `${process.env.VUE_APP_BASE_URI}/absence/validate`;
        //   const absence = {
        //     user: u._id,
        //     group: u.group ? u.group._id : null,
        //     from: this.date,
        //     to: this.date,
        //   };
        //   let isAbsent = await this.$http.post(url, absence);
        //   if (isAbsent.data.state) {
        //       this.$set(u, "state", isAbsent.data.state);
        //       // disable user only when user is absent or in vacation
        //       if(isAbsent.data.state !== 'planned' && isAbsent.data.state !== 'reported') {
        //         this.$set(u, "disabled", true);
        //       }
        //   }
        //   // isDisabled if user is absent in that period
        //   // if (!isAbsent.data.valid) {
        //   //   if (!u.isFromReport) {
        //   //     this.$set(u, "isDisabled", true);
        //   //     this.$snotify.error(
        //   //       `${u.name} е вече планиран, отчетен или в отпуск за този период`
        //   //     );
        //   //   }
        //   // }
        // }
        if (u.group && this.isCommingFromGroup) {
          if (
            (this.groupId && u.group._id !== this.groupId) || // EDIT GROUP USERS if group user is in another group
            (u.group._id && !this.groupId) // NEW GROUP when he already has group
          )
            this.$set(u, "isDisabled", true);
        }
      }
    },
    getAllUsers() {
      let url;
      if (this.allUsers || this.usersType === "noPermissions")
        url = `${process.env.VUE_APP_BASE_URI}/auth/users?noWorkers=true`; // gets all users except isWorkers permision
      else url = `${process.env.VUE_APP_BASE_URI}/auth/users/${this.usersType}`;

      this.$http.get(url).then((response) => {
        this.users = response.data;
        // if (this.date) {
        //   this.getAbsentWorkers();
        // }
        this.setSelectedProps(this.users);
        this.setDisabledUsers();
      });
    },
    setSelectedProps(array) {
      if (this.incomingUsers) {
        this.incomingUsers.forEach((iu) => {
          array.forEach((u) => {
            if (u._id === iu._id) {
              if (iu.isObjectLeader) {
                this.$set(u, "isObjectLeader", true);
              }
              u.isSelected = true;
              u.isFromReport = true;
              if (u.isDisabled) u.isSelected = false;

              if (iu.isFromGroup) {
                u.isFromGroup = iu.isFromGroup;
              }
              if (iu.group) {
                u.group = iu.group;
              }
              if (iu.startHour) {
                u.startHour = iu.startHour;
              }
              if (iu.startHourDate) {
                u.startHourDate = iu.startHourDate;
              }
              if (iu.coefficient) {
                u.coefficient = iu.coefficient;
              }
              if (iu.endHour) {
                u.endHour = iu.endHour;
              }
              if (iu.endHourDate) {
                u.endHourDate = iu.endHourDate;
              }
              if (iu.new) {
                u.new = iu.new;
              }
              if (iu.elsewhereConfirmed) {
                u.elsewhereConfirmed = iu.elsewhereConfirmed;
              }

              // when manualy change the isSelected state this should become false and his current wage should be assigned to the user
              if (this.isCommingFromReport) {
                u.useIncomingWage = true;
                u.incomingWage = iu.wage;
              }
            }
          });
        });
      }
    },
    getAllWorkerGroups() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(
          `${process.env.VUE_APP_BASE_URI}/group?active=true&workerGroups=true`
        )
        .then((response) => {
          this.workerGroups = response.data;
          setTimeout(() => {
            this.setSelectedProps(this.workerGroups);
            this.$store.dispatch("stopLoading");
          }, 100);
        });
    },
    getAllGropus() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group?active=true&notEmpty=true`)
        .then((response) => {
          this.groups = response.data;
          this.groups.map((g) => {
            this.$http
              .get(`${process.env.VUE_APP_BASE_URI}/group/users/${g._id}`)
              .then((res) => {
                this.$set(g, "users", res.data);

                if (this.incomingUsers) {
                  let count = 0;
                  this.incomingUsers.forEach((x) => {
                    res.data.forEach((r) => {
                      if (x._id === r._id) count++;
                    });
                  });

                  if (res.data.length === count)
                    this.$set(g, "isSelected", true);
                }
              });
          });
        });
    },
    filterUsers() {
      let array = this.users;
      if (this.selectedUsersType === "groups") array = this.groups;
      // if (this.selectedUsersType === "workers") array = this.workers;
      if (this.selectedUsersType === "workers-groups")
        array = this.workerGroups;
      return array.filter((u) => {
        return u.name.toLowerCase().includes(this.searchUsers.toLowerCase());
      });
    },
    getUsers(type) {
      this.selectedUsersType = type;
    },
    setLeader(u) {
      if (u.isSelected) {
        this.users.forEach((user) => {
          if (user.isObjectLeader && u._id.toString() !== user._id.toString())
            user.isObjectLeader = false;
        });
        this.$set(u, "isObjectLeader", !u.isObjectLeader);
      }
    },
    setSelectedUsersOrGroups(v) {
      if (this.selectedUsersType === "groups") {
        // selects/ deselects all users in group
        if (v.users && v.users.length) {
          for (let x of v.users) {
            for (let u of this.users) {
              if (x._id === u._id) {
                (u.isSelected = v.isSelected ? false : true),
                  (u.isFromGroup = true);
              }
              if (u.isDisabled) u.isSelected = false;
            }
          }
        }
      }
      v.isSelected = !v.isSelected;
      if (
        this.isCommingFromCompany &&
        v.permissions.isLeader &&
        v.isObjectLeader
      ) {
        this.$set(v, "isObjectLeader", false);
      }
      if (v.isDisabled) v.isSelected = false;
    },
    getSelectedUsers() {
      let selected = [];

      for (let tag of ["users", "workers", "workerGroups"]) {
        if (this[tag] && this[tag].length) {
          for (let u of this[tag]) {
            if (u.isSelected && u.useIncomingWage && this.isCommingFromReport) {
              u.wage = u.incomingWage;
            }
            // if (tag === "workerGroups") u.name = `${u.worker.name} - ${u.name}`;
            if (u.isSelected) selected.push(u);
          }
        }
      }

      return selected;
    },
    close() {
      this.$parent.$emit("closeAddUsersModal");
    },
    save() {
      if (this.isCommingFromCompany) {
        if (!this.users.filter((u) => u.isObjectLeader).length)
          return this.$snotify.error(
            `Задължително трябва да добавите рък. обект`
          );
      }
      this.$parent.$emit("saveAddUsersModal", this.getSelectedUsers());
    },
  },
  mounted() {
    if (this.allUsers) this.selectedUsersType = "groups";

    this.getAllUsers();
    this.getAllGropus();
    this.getAllWorkerGroups();
    // this.getAllWorkers();
    this.$eventBus.$on("closeModalFromSpeechRecognition", () => {
      this.close();
    });
  },
  destroyed() {
    this.$eventBus.$off("closeModalFromSpeechRecognition");
  },
};
</script>

<style scoped lang='scss'>
/* Responsive */
.modal-content-check {
  padding: 10px;
  position: relative;

  .tms-leader {
    position: absolute;
    left: 0px;
    transform: translate(-50%, -50%);
    top: 50%;
    font-size: 15px;
  }
}
.modal-content-check-disabled {
  background-color: #f3eae6;
  opacity: 0.5;
}

.btn--selected {
  background: #00408a;
  color: white;
}

@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    display: flex;
    margin: 10px 0;
    overflow: auto;
    width: 100%;
    white-space: nowrap;
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;

    /* Firefox */
    &::-webkit-scrollbar {
      display: none;
      /* Safari and Chrome */
    }
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
